module.exports = __webpack_public_path__ + "media/images/village/bg-gradient-light-a51cf4f095a6601d577551952417e092.jpg";